import React from "react";
import "./styles.scss";

const Button = (props) => {
  const { text = "Button", state = "PRIMARY", ...rest } = props;
  return (
    <div className="relative w-[10rem]">
      <button className={state === "PRIMARY" ? "arrow-button" : state === "SECONDARY" ? "arrow-button-black" : "arrow-button-white"} {...rest}><span className="arrow"></span><span className="absolute">{text}</span></button>
    </div>
  );
};

export default Button;